module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venues/venues.component.scss
// module id = ./src/app/routes/venues/venues.component.scss
// module chunks = 9